import { useEffect, useRef, useState } from "react";
import { ws } from "src/services/ws";

import { sendChromeEvent } from "src/helpers";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { createDialerInstance } from "src/services/dialer";
import { addDialerInstance, initCall } from "src/store/call/reducer";
import { inCall, setIdle } from "src/store/context/reducer";
import { toast } from "react-toastify";

// Components
import PhoneRingAudio from "src/assets/sounds/phone-ringing.mp3";
import ScreenLoader from "src/components/screen-loader";
import { trackEvent } from "src/services/logger";

export default function RigingComponent() {
  const [attending, setAttending] = useState(false);
  const { callDetails } = useAppSelector((state) => state.call);
  const dispatch = useAppDispatch();

  const handleAnswerCall = async () => {
    setAttending(true);
    let answerEvent: any = { type: "PA_ANSWERED_CALL" };

    // Configure event in case 142
    if (callDetails && ["PSTN", "ICOM_VOZ"].includes(callDetails!.callType)) {
      const client = await createDialerInstance({ remoteAudioEl: undefined }, "VOIP", {
        aderenteSlug: callDetails!.aderenteSlug,
      });

      // Update current call
      client.createCall(callDetails.pstnNumbers[0].requestedNumber!);

      const createClientResult = await client.createSimpleUser(callDetails!.aderenteSlug);

      // Case error
      if (!createClientResult.success && !createClientResult.data.ramal) {
        toast.error("Falha ao atender chamada por falha na alocação de ramal");

        setAttending(false);
        return false;
      }

      answerEvent.data = {
        ramalVoip: createClientResult.data.ramal, //accessDotNotation(self, "sipConfigurations.defaultSipConfiguration.ramal") ? accessDotNotation(self, "sipConfigurations.defaultSipConfiguration.ramal") : self.pa().ramal,
      };

      // Save instance
      dispatch(addDialerInstance(client));
    }

    try {
      const eventData = await ws.request(answerEvent, { responseType: "PA_ANSWERED_CALL_INFO" });

      if (callDetails?.callType === "ICOM_VOZ") {
        delete eventData["twilioRoomName"];
        delete eventData["twilioToken"];
      }

      dispatch(inCall());
      dispatch(initCall({ ...eventData }));
      trackEvent("incoming_call_answered", { call_type: callDetails?.callType });
    } catch (error) {
      setAttending(false);
      dispatch(setIdle());
      toast.error("Não foi possível concluir o atendimento. Tente novamente.");
    }
  };

  const timeoutRef = useRef<NodeJS.Timeout>(undefined);

  const audio = new Audio(PhoneRingAudio);

  useEffect(() => {
    audio.loop = true;
    audio.play();

    const message = "Ligação em andamento";

    let oldTitle = document.title; /* save original title */
    let timeoutId: any;

    const blink = function () {
      document.title = document.title == message ? " " : message;
    };

    const clear = function () {
      /* function to set title back to original */
      clearInterval(timeoutRef.current);
      document.title = oldTitle;
      window.onmousemove = null;
      timeoutId = null;
    };

    if (!timeoutId) {
      timeoutRef.current = setInterval(blink, 1000);
      window.onmousemove = clear; /* stop changing title on moving the mouse */
    }

    sendChromeEvent({
      type: "SF/FOCUS_TAB",
    });

    return () => {
      audio.pause();
      clear();
    };
  }, []);

  return (
    <div
      data-testid="ringing-component"
      className="actions flex flex-col gap-x-3 absolute top-0 left-0 w-full h-full justify-center items-center gap-5"
      style={{
        background: "rgba(16, 16, 46, 0.90)",
        backdropFilter: "blur(13px)",
      }}
    >
      <button
        disabled={attending}
        type="button"
        onClick={handleAnswerCall}
        className={`
          ${!attending ? "bg-feedback-positive-500 text-white" : "bg-[#7e2a0c] text-orange-500"}
          hover:not-disabled:opacity-85 
          ${!attending && "h-50 w-50"} px-6 p-2
          
          rounded-full
          transition-all
        `}
      >
        <span className="text-base font-bold">
          {attending ? (
            <ScreenLoader
              label="Carregando chamada"
              options={{
                fullScreen: false,
                color: "oklch(70.5% 0.213 47.604)",
              }}
            />
          ) : (
            "Atender"
          )}
        </span>
      </button>

      {callDetails?.servico.fila === "icom" && callDetails?.aderenteSlug !== "icom-qa" && (
        <div className="company-name text-base text-white">
          Empresa: <span className="font-medium text-gray-300">{callDetails?.aderenteName}</span>
        </div>
      )}
    </div>
  );
}
